import styled from 'styled-components';

interface IIconsComp {
  fill?: string;
  opacity?: number;
  margin?: string;
  iconSize?: number;
  rotate?: string;
}

export const IconsComp = styled.span`
  height: ${(props: IIconsComp) => props.iconSize && `${props.iconSize}px`};
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    transform: ${(props: IIconsComp) => (props.rotate ? `rotate(${props.rotate})` : 'rotate(0deg)')};
    overflow: hidden;
    transition: all 0.1s ease-out;
    color: ${(props: IIconsComp) => props.fill && props.fill};
    opacity: ${(props: IIconsComp) => props.opacity && props.opacity};
    font-size: ${(props: IIconsComp) => props.iconSize && `${props.iconSize}px`};
    margin: ${(props: IIconsComp) => props.margin && props.margin};
  }
`;
